export const DeviceServerModel = {
    name: "",
    description: "",
    has:{},
    values:{}
}
